const easeInOutCubic = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2)

export function smoothScrollToElement(element, { headerOffset = 96 } = {}) {
  if (!element) return
  const startY = window.pageYOffset || document.documentElement.scrollTop
  const targetY = element.getBoundingClientRect().top + startY - headerOffset
  const distance = targetY - startY
  if (Math.abs(distance) < 1) return
  const duration = Math.min(900, Math.max(450, Math.abs(distance) * 0.6))
  const startTime = performance.now()
  const step = (now) => {
    const elapsed = now - startTime
    const progress = Math.min(1, elapsed / duration)
    window.scrollTo(0, startY + distance * easeInOutCubic(progress))
    if (progress < 1) requestAnimationFrame(step)
  }
  requestAnimationFrame(step)
}

export function smoothScrollToId(id, options) {
  smoothScrollToElement(document.getElementById(id), options)
}
